var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLoader(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    style: {
      margin: "auto",
      background: "transparent",
      display: "block"
    },
    width: "200px",
    height: "200px",
    viewBox: "0 0 100 100",
    preserveAspectRatio: "xMidYMid",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(50 50)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "scale(0.6432246208212566)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0L0 -40A40 40 0 0 1 19.999999999999996 -34.64101615137755",
    transform: "rotate(0 0 0)",
    stroke: "none",
    fill: "#de653a"
  }), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    values: "0.6432246208212566;0.710913858282441;0.45409707977445235;0.240795729866353;0.7791253993920784;0.6432246208212566",
    keyTimes: "0;0.2;0.4;0.6;0.8;1",
    dur: "1s",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "scale(0.5874993683125069)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0L0 -40A40 40 0 0 1 19.999999999999996 -34.64101615137755",
    transform: "rotate(30 0 0)",
    stroke: "none",
    fill: "#107691"
  }), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    values: "0.5874993683125069;0.3441813559074618;0.5049759518522203;0.8943720151139771;0.8126036774873697;0.5874993683125069",
    keyTimes: "0;0.2;0.4;0.6;0.8;1",
    dur: "1s",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "scale(0.3871004393577957)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0L0 -40A40 40 0 0 1 19.999999999999996 -34.64101615137755",
    transform: "rotate(60 0 0)",
    stroke: "none",
    fill: "#18b2dc"
  }), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    values: "0.3871004393577957;0.2632043681810663;0.11555340789464763;0.4977226413891158;0.3871004393577957",
    keyTimes: "0;0.25;0.5;0.75;1",
    dur: "1s",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "scale(0.7434908539384513)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0L0 -40A40 40 0 0 1 19.999999999999996 -34.64101615137755",
    transform: "rotate(90 0 0)",
    stroke: "none",
    fill: "#ff931e"
  }), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    values: "0.7434908539384513;0.29148678793256755;0.4295947073007593;0.059026498571739694;0.7434908539384513",
    keyTimes: "0;0.25;0.5;0.75;1",
    dur: "1s",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "scale(0.24881714242487885)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0L0 -40A40 40 0 0 1 19.999999999999996 -34.64101615137755",
    transform: "rotate(120 0 0)",
    stroke: "none",
    fill: "#de653a"
  }), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    values: "0.24881714242487885;0.42405725788617077;0.9490265407624747;0.24881714242487885",
    keyTimes: "0;0.3333333333333333;0.6666666666666666;1",
    dur: "1s",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "scale(0.019134095400358708)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0L0 -40A40 40 0 0 1 19.999999999999996 -34.64101615137755",
    transform: "rotate(150 0 0)",
    stroke: "none",
    fill: "#107691"
  }), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    values: "0.019134095400358708;0.7894366179067267;0.7602670250303669;0.034965157645550304;0.019134095400358708",
    keyTimes: "0;0.25;0.5;0.75;1",
    dur: "1s",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "scale(0.7169537312497607)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0L0 -40A40 40 0 0 1 19.999999999999996 -34.64101615137755",
    transform: "rotate(180 0 0)",
    stroke: "none",
    fill: "#18b2dc"
  }), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    values: "0.7169537312497607;0.17023896303114205;0.5087759635096807;0.08391758651152093;0.7169537312497607",
    keyTimes: "0;0.25;0.5;0.75;1",
    dur: "1s",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "scale(0.7784928761802985)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0L0 -40A40 40 0 0 1 19.999999999999996 -34.64101615137755",
    transform: "rotate(210 0 0)",
    stroke: "none",
    fill: "#ff931e"
  }), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    values: "0.7784928761802985;0.7623578645226867;0.22914770189484424;0.7784928761802985",
    keyTimes: "0;0.3333333333333333;0.6666666666666666;1",
    dur: "1s",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "scale(0.638103712879112)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0L0 -40A40 40 0 0 1 19.999999999999996 -34.64101615137755",
    transform: "rotate(240 0 0)",
    stroke: "none",
    fill: "#de653a"
  }), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    values: "0.638103712879112;0.5980265487808916;0.29997103965522354;0.2376310718385306;0.638103712879112",
    keyTimes: "0;0.25;0.5;0.75;1",
    dur: "1s",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "scale(0.21233854829378696)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0L0 -40A40 40 0 0 1 19.999999999999996 -34.64101615137755",
    transform: "rotate(270 0 0)",
    stroke: "none",
    fill: "#107691"
  }), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    values: "0.21233854829378696;0.018143043033770123;0.5402038957472575;0.6512336918837014;0.6251888931473844;0.21233854829378696",
    keyTimes: "0;0.2;0.4;0.6;0.8;1",
    dur: "1s",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "scale(0.39654418503312727)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0L0 -40A40 40 0 0 1 19.999999999999996 -34.64101615137755",
    transform: "rotate(300 0 0)",
    stroke: "none",
    fill: "#18b2dc"
  }), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    values: "0.39654418503312727;0.06367946104773381;0.9202096007580189;0.5412058165886442;0.39654418503312727",
    keyTimes: "0;0.25;0.5;0.75;1",
    dur: "1s",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "scale(0.9753181242131888)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0L0 -40A40 40 0 0 1 19.999999999999996 -34.64101615137755",
    transform: "rotate(330 0 0)",
    stroke: "none",
    fill: "#ff931e"
  }), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    values: "0.9753181242131888;0.2274038244376264;0.23395430691992614;0.561980075229507;0.9753181242131888",
    keyTimes: "0;0.25;0.5;0.75;1",
    dur: "1s",
    repeatCount: "indefinite"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoader);
export default __webpack_public_path__ + "static/media/loader.ff0b11ee6fe1ff59a80279da58c9a221.svg";
export { ForwardRef as ReactComponent };